// extracted by mini-css-extract-plugin
export default {"section":"WA_i1","icon":"_kZRQ"};